module.exports = __webpack_public_path__ + "img/MRC_IEU.0c13b8b5.png";